import React from 'react';
import { RadioButtonGroup, RadioButton } from 'material-ui';
import CancellationRules from './rules';

const SingleCancellationPolicy = ({
  index,
  cancelNum,
  cancelHoursDays,
  conditions,
  additionalRules,
  onTextFieldChange,
  showError,
}) => {
  return (
    <div>
      Same as location cancellation policy:
      <RadioButtonGroup
        name="sameAsLocation"
        valueSelected={conditions === 'Same as location cancellation policy' ? 'yes' : 'no'}
        style={{ display: 'inline-block', position: 'relative', top: '6px', marginLeft: '15px' }}
        onChange={(_, val) => onTextFieldChange(index, 'conditions', val === 'yes' ? 'Same as location cancellation policy' : '')}
      >
        <RadioButton label="Yes" value="yes" style={{ display: 'inline-block', width: '75px' }}/>
        <RadioButton label="No" value="no" style={{ display: 'inline-block', width: '65px' }}/>
      </RadioButtonGroup>
      <div style={{ display: conditions === 'Same as location cancellation policy' ? 'none' : 'block' }}>
        <CancellationRules
          cancelNum={cancelNum}
          cancelHoursDays={cancelHoursDays}
          conditions={conditions}
          additionalRules={additionalRules}
          onChange={(key, value) => onTextFieldChange(index, key, value)}
          showError={showError}
        />
      </div>
    </div>);
};

export default SingleCancellationPolicy;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/seasonal-cancellation-policy/single-cancellation-policy.jsx